import React, {useEffect, useState} from "react";
import "./style.css";
import {VscGrabber, VscClose} from "react-icons/vsc";
import {Link, useLocation} from "react-router-dom";
import {contactConfig, logotext, socialprofils} from "../content_option";
import Themetoggle from "../components/themetoggle";

const Headermain = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setIsMenuOpen(false);
    }, [location.pathname]);

    const handleToggle = () => {
        setIsMenuOpen((open) => !open);
    };

    const handleClose = () => {
        setIsMenuOpen(false);
    };

    return (
        <>
            <header className="fixed-top site__header">
                <div className="d-flex align-items-center justify-content-between">
                    <Link className="navbar-brand nav_ac" to="/">
                        {logotext}
                    </Link>
                    <div className="d-flex align-items-center">
                        <Themetoggle/>
                        <button
                            type="button"
                            className="menu__button  nav_ac"
                            onClick={handleToggle}
                            aria-expanded={isMenuOpen}
                            aria-label="Toggle navigation menu"
                        >
                            {isMenuOpen ? <VscClose/> : <VscGrabber/>}
                        </button>

                    </div>
                </div>

                <div className={`site__navigation ${isMenuOpen ? "menu__opend" : ""}`}>
                    <div className="bg__menu h-100">
                        <div className="menu__wrapper">
                            <div className="menu__container p-3">
                                <ul className="the_menu">
                                    <li className="menu_item ">
                                        <Link onClick={handleClose} to="/" className="my-3">Home</Link>
                                    </li>
                                    {/*<li className="menu_item">*/}
                                    {/*  <Link  onClick={handleToggle} to="/portfolio" className="my-3"> Portfolio</Link>*/}
                                    {/*</li>*/}
                                    <li className="menu_item">
                                        <Link onClick={handleClose} to="/about" className="my-3">About</Link>
                                    </li>
                                    <li className="menu_item">
                                        <a
                                            href={`mailto:${contactConfig.YOUR_EMAIL}`}
                                            onClick={handleClose}
                                            className="my-3"
                                        >
                                            Contact
                                        </a>
                                    </li>
                                    <li className="menu_item">
                                        <Link onClick={handleClose} to="/legal-notice" className="my-3">Legal
                                            notice</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div
                        className="menu_footer d-flex flex-column flex-md-row justify-content-between align-items-md-center position-absolute w-100 p-3">
                        <div className="d-flex">
                            {/*<a href={socialprofils.facebook}>Facebook</a>*/}
                            <a href={socialprofils.github}>Github</a>
                            {/*<a href={socialprofils.twitter}>Twitter</a>*/}
                        </div>
                    </div>
                </div>
            </header>

            <div className="br-top"></div>
            <div className="br-bottom"></div>
            <div className="br-left"></div>
            <div className="br-right"></div>
        </>
    );
};

export default Headermain;
